/**
 * Breakpoint constants for responsive design
 * These values should match the SCSS breakpoint variables
 */
export const BREAKPOINTS = {
  PHONE_MINIMUM: 360,
  PHONE_LARGE_MINIMUM: 425,
  TABLET_MINIMUM: 600, // sm
  TABLET_LARGE_MINIMUM: 840,
  DESKTOP_MINIMUM: 1024, // md
  DESKTOP_MEDIUM_MINIMUM: 1280,
  DESKTOP_LARGE_MINIMUM: 1440, // lg
} as const;

/**
 * Breakpoint constants with 'px' suffix for direct use in CSS-in-JS
 */
export const BREAKPOINTS_PX = {
  PHONE_MINIMUM: '360px',
  PHONE_LARGE_MINIMUM: '425px',
  TABLET_MINIMUM: '600px', // sm
  TABLET_LARGE_MINIMUM: '840px',
  DESKTOP_MINIMUM: '1024px', // md
  DESKTOP_MEDIUM_MINIMUM: '1280px',
  DESKTOP_LARGE_MINIMUM: '1440px', // lg
} as const;
